module.exports = __webpack_public_path__ + "img/mg.20f20f2b.svg";